module.exports = __webpack_public_path__ + "img/banner3_4_th.8a2e1fe1.png";